import { TextInput, TextInputProps } from '@mantine/core';
import { forwardRef } from 'react';

import classNames from './TextInput.module.scss';

export type ITextInputProps = Omit<TextInputProps, 'value'> & {
  value?: string;
  isMasked?: boolean;
  isReadOnly?: boolean;
  dataVariant?: 'transparent';
};

/**
 * @deprecated Use `TextInput` from `@zorro/design-system/v2/TextInput` instead.
 * This component will be removed in the next major version.
 *
 * Migration guide:
 * - Replace `<ZorroTextInput>` with `<TextInput>` from v2
 * - Update imports: `import { TextInput } from '@zorro/design-system/v2/TextInput'`
 * - `size` prop values changed to `'md' | 'lg'`
 * - `dataVariant` prop removed
 * - `masked` prop removed (handle separately if needed)
 */
export const ZorroTextInput = forwardRef<HTMLInputElement, ITextInputProps>(
  (
    {
      size = 'lg',
      disabled = false,
      isMasked = false,
      isReadOnly = false,
      placeholder,
      dataVariant,
      ...props
    },
    ref
  ) => {
    const inputClassNames = [
      classNames.input ?? null,
      isMasked ? 'fs-mask' : null,
    ].filter((className): className is string => Boolean(className));

    return (
      <TextInput
        ref={ref}
        size={size}
        classNames={{
          ...classNames,
          input: inputClassNames.join(' '),
        }}
        labelProps={{
          'data-disabled': disabled,
        }}
        data-variant={dataVariant}
        disabled={disabled}
        data-readonly={isReadOnly}
        placeholder={isReadOnly ? '-' : placeholder}
        {...props}
      />
    );
  }
);

ZorroTextInput.displayName = 'ZorroTextInput';

export default ZorroTextInput;
